import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { cachedSerialNames31jc5fovi62px as cachedSerialNames } from './Platform.common.mjs';
import { SerialDescriptor2pelqekb5ic3a as SerialDescriptor } from '../descriptors/SerialDescriptor.mjs';
import { CachedNames2minxlyafeo07 as CachedNames } from './CachedNames.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var NullableSerializerClass;
function NullableSerializer() {
  if (NullableSerializerClass === VOID) {
    class $ {
      constructor(serializer) {
        this.e20_1 = serializer;
        this.f20_1 = new (SerialDescriptorForNullable())(this.e20_1.x1m());
      }
      x1m() {
        return this.f20_1;
      }
      g20(encoder, value) {
        if (!(value == null)) {
          encoder.k1t();
          encoder.h1t(this.e20_1, value);
        } else {
          encoder.k1s();
        }
      }
      y1m(encoder, value) {
        return this.g20(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
      z1m(decoder) {
        return decoder.z1q() ? decoder.n1r(this.e20_1) : decoder.a1r();
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof NullableSerializer()))
          THROW_CCE();
        if (!equals(this.e20_1, other.e20_1))
          return false;
        return true;
      }
      hashCode() {
        return hashCode(this.e20_1);
      }
    }
    initMetadataForClass($, 'NullableSerializer', VOID, VOID, [KSerializer()]);
    NullableSerializerClass = $;
  }
  return NullableSerializerClass;
}
var SerialDescriptorForNullableClass;
function SerialDescriptorForNullable() {
  if (SerialDescriptorForNullableClass === VOID) {
    class $ {
      constructor(original) {
        this.n1p_1 = original;
        this.o1p_1 = this.n1p_1.a1o() + '?';
        this.p1p_1 = cachedSerialNames(this.n1p_1);
      }
      a1o() {
        return this.o1p_1;
      }
      x1q() {
        return this.p1p_1;
      }
      m1p() {
        return true;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SerialDescriptorForNullable()))
          return false;
        if (!equals(this.n1p_1, other.n1p_1))
          return false;
        return true;
      }
      toString() {
        return toString(this.n1p_1) + '?';
      }
      hashCode() {
        return imul(hashCode(this.n1p_1), 31);
      }
      t1p() {
        return this.n1p_1.t1p();
      }
      u1p() {
        return this.n1p_1.u1p();
      }
      v1p() {
        return this.n1p_1.v1p();
      }
      w1p() {
        return this.n1p_1.w1p();
      }
      x1p(index) {
        return this.n1p_1.x1p(index);
      }
      y1p(name) {
        return this.n1p_1.y1p(name);
      }
      z1p(index) {
        return this.n1p_1.z1p(index);
      }
      a1q(index) {
        return this.n1p_1.a1q(index);
      }
      b1q(index) {
        return this.n1p_1.b1q(index);
      }
    }
    initMetadataForClass($, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor(), CachedNames()]);
    SerialDescriptorForNullableClass = $;
  }
  return SerialDescriptorForNullableClass;
}
//region block: exports
export {
  NullableSerializer as NullableSerializer41etqlj0tdq5,
  SerialDescriptorForNullable as SerialDescriptorForNullable2slcv65za9oog,
};
//endregion

//# sourceMappingURL=NullableSerializer.mjs.map
